module.exports = __webpack_public_path__ + "img/10.5a2819e0.png";